export default __webpack_public_path__ + "10460a3b437531f972f65b37f3e0d9f2.svg";